import { Code, Bug, FileCode, Lightbulb, RefreshCw, Shield } from "lucide-react";

export const AiCodingUseCases = () => {
  const useCases = [
    {
      icon: Code,
      title: "Code Generation",
      description: "Generate functions, components, or entire features from descriptions.",
      recommendation: "Cursor or Copilot for speed, Claude for complex logic",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Bug,
      title: "Debugging",
      description: "Find and fix bugs by explaining the issue or pasting error messages.",
      recommendation: "Claude for complex bugs, ChatGPT for quick fixes",
      color: "text-destructive",
      bgColor: "bg-destructive/10",
    },
    {
      icon: FileCode,
      title: "Refactoring",
      description: "Improve code structure, performance, or readability.",
      recommendation: "Cursor for multi-file, Claude for architecture decisions",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Lightbulb,
      title: "Learning",
      description: "Understand unfamiliar code, learn new patterns, get explanations.",
      recommendation: "Claude for deep explanations, ChatGPT for quick answers",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
    {
      icon: RefreshCw,
      title: "Code Review",
      description: "Get feedback on code quality, security, and best practices.",
      recommendation: "Claude for thorough reviews, Copilot for quick suggestions",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
    {
      icon: Shield,
      title: "Security Analysis",
      description: "Identify vulnerabilities and security issues in your code.",
      recommendation: "Claude for comprehensive analysis, ChatGPT for OWASP checks",
      color: "text-chart-3",
      bgColor: "bg-chart-3/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Best Tool for Each Use Case
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        Different tasks call for different tools. Here's our recommendation for each common use case.
      </p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        {useCases.map((useCase, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:shadow-lg transition-shadow"
          >
            <div className={`w-12 h-12 rounded-xl ${useCase.bgColor} flex items-center justify-center mb-4`}>
              <useCase.icon className={`w-6 h-6 ${useCase.color}`} />
            </div>
            <h3 className="text-lg font-semibold text-foreground mb-2">{useCase.title}</h3>
            <p className="text-sm text-muted-foreground mb-4">{useCase.description}</p>
            <div className="text-sm text-primary bg-primary/5 p-3 rounded-lg">
              <strong>Recommended:</strong> {useCase.recommendation}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
